export const validateEmail = (value) => {
  if (!value) return true;
  const regex = /^[\p{L}\p{N}][\p{L}\p{N}.!#$%&'*+=?^_`{|}~-]*@(?:[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?\.)+[\p{L}]{2,}$/iu;
  return regex.test(String(value).trim());
}
